<template>
    <div v-if="showSelect" class="ct-language">
        <span>{{ $t('language.choose.label') }}</span>
        <div class="input-group">
            <select class="form-control" v-model="selectedLanguage">
                <option v-for="language in dropdownLanguages" :value="language">{{ getLanguage(language) }}</option>
            </select>
        </div>
    </div>
</template>

<script>
import * as types from '../../store/mutation-types';

export default {
    components: {},
    data() {
        return {
            dropdownLanguages: ['de', 'en', 'pt', 'fr']
        };
    },
    computed: {
        selectedLanguage: {
            get() {
                return this.$store.getters['getLanguage'];
            },
            set(value) {
                this.$store.commit(types.LANGUAGE_CHANGE, value);
            }
        },
        showSelect: function() {
            return this.$store.getters['getLanguage'] !== 'de-kr';
        }
    },
    methods: {
        getLanguage(code) {
            var languageMapping = {
                de: 'Deutsch',
                en: 'English',
                pt: 'Português',
                fr: 'Français'
            };
            return languageMapping[code];
        }
    }
};
</script>
<style></style>
